import { Action } from 'redux';

import { LayoutType } from '../../state/LayoutType';
import { SetLayoutType } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';


export interface SetLayoutTypeAction extends Action {
  layoutType: LayoutType;
}

export function setLayoutType(layoutType: LayoutType): SetLayoutTypeAction {
  return {
    type: SetLayoutType,
    layoutType: layoutType
  };
}

export const isSetLayoutTypeAction = isActionFactory<SetLayoutTypeAction>(SetLayoutType);
